import { Link } from "react-router-dom";
import {
  COMPANY,
  SOCIAL_LINKS,
  FOOTER_SERVICES,
  FOOTER_EVENTS,
  FOOTER_COMPANY,
  BADGES,
} from "@data/constants";

function SocialIcon({ platform }) {
  if (platform === "LinkedIn")
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    );
  if (platform === "Facebook")
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    );
  if (platform === "Instagram")
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    );
  if (platform === "YouTube")
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    );
  return null;
}

export default function Footer() {
  return (
    <footer
      aria-label="Site footer"
      className="relative bg-[#050505] overflow-hidden"
    >
      {/* Ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-konecta-orange/[0.03] blur-[120px] rounded-full pointer-events-none" />

      {/* Main footer grid */}
      <div className="relative z-10 content-px py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="font-logo text-2xl font-extrabold tracking-tight mb-4 text-konecta-orange">
              KONECTA
            </div>
            <p className="text-white/80 leading-relaxed mb-6 max-w-[280px]">
              Africa&apos;s AI-powered technology and digital infrastructure
              company. Building platforms that connect, automate, and transform.
            </p>
            <div className="flex flex-col gap-2">
              {BADGES.map((badge) => (
                <span
                  key={badge}
                  className="text-[0.65rem] font-bold uppercase tracking-widest text-konecta-gold border border-konecta-gold/20 rounded-lg px-3 py-1.5 w-fit backdrop-blur-sm bg-konecta-gold/[0.03]"
                >
                  {badge}
                </span>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <div className="font-heading text-xs font-bold uppercase tracking-widest text-konecta-white mb-6">
              Services
            </div>
            <ul className="flex flex-col gap-3 list-none">
              {FOOTER_SERVICES.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-white/80 no-underline hover:text-konecta-white transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Events + Company */}
          <div>
            <div className="font-heading text-xs font-bold uppercase tracking-widest text-konecta-white mb-6">
              Events
            </div>
            <ul className="flex flex-col gap-3 list-none mb-10">
              {FOOTER_EVENTS.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-white/80 no-underline hover:text-konecta-white transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="font-heading text-xs font-bold uppercase tracking-widest text-konecta-white mb-6">
              Company
            </div>
            <ul className="flex flex-col gap-3 list-none">
              {FOOTER_COMPANY.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-white/80 no-underline hover:text-konecta-white transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="font-heading text-xs font-bold uppercase tracking-widest text-konecta-white mb-6">
              Get in Touch
            </div>
            <ul className="flex flex-col gap-3 list-none mb-8">
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="text-sm text-white/80 no-underline hover:text-konecta-white transition-colors"
                >
                  {COMPANY.email}
                </a>
              </li>
              {COMPANY.phone && (
                <li>
                  <a
                    href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}
                    className="text-sm text-white/80 no-underline hover:text-konecta-white transition-colors"
                  >
                    {COMPANY.phone}
                  </a>
                </li>
              )}
              <li>
                <span className="text-sm text-white/80">
                  {COMPANY.location}
                </span>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-konecta-orange no-underline hover:text-konecta-white transition-colors font-bold"
                >
                  Request a Proposal
                </Link>
              </li>
            </ul>
            <div className="flex gap-3">
              {SOCIAL_LINKS.map((s) => (
                <a
                  key={s.platform}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg glass-card flex items-center justify-center text-white/50 no-underline hover:border-konecta-orange hover:text-konecta-orange transition-all"
                  aria-label={s.platform}
                >
                  <SocialIcon platform={s.platform} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="relative z-10 content-px py-6 border-t border-[rgba(255,255,255,0.06)] flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="text-xs text-white/75 text-center sm:text-left">
          &copy; {COMPANY.year} Konecta. {COMPANY.registrationNote} &middot;{" "}
          {COMPANY.location}
        </div>
        <div className="text-xs text-white/50 hidden sm:block">
          Designed &amp; developed by{" "}
          <span className="text-konecta-orange font-bold">Konecta</span>{" "}
          <span className="text-konecta-orange">&bull;</span> South Africa
        </div>
        <div className="text-xs text-white/75 flex gap-4">
          <Link
            to="/privacy-policy"
            className="no-underline text-inherit hover:text-konecta-white transition-colors"
          >
            Privacy Policy
          </Link>
          <span className="hover:text-konecta-white transition-colors cursor-pointer">
            Terms of Service
          </span>
          <Link
            to="/privacy-policy#popia"
            className="no-underline text-inherit hover:text-konecta-white transition-colors"
          >
            POPIA
          </Link>
        </div>
      </div>

      {/* Floating WhatsApp button */}
      <a
        href="https://wa.me/27721300531"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-20 z-50 w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 hover:shadow-[0_8px_30px_rgba(37,211,102,0.4)] transition-all duration-300"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-5 h-5 fill-white"
        >
          <path d="M16.004 0h-.008C7.174 0 .002 7.174.002 16.002c0 3.5 1.129 6.744 3.047 9.381L1.06 31.372l6.182-1.96A15.905 15.905 0 0 0 16.004 32C24.83 32 32 24.826 32 15.998S24.83 0 16.004 0zm9.32 22.602c-.39 1.1-2.276 2.103-3.156 2.18-.878.076-1.697.396-5.716-1.19-4.852-1.916-7.896-6.93-8.132-7.252-.236-.322-1.93-2.567-1.93-4.893s1.222-3.47 1.656-3.944c.435-.474.948-.593 1.264-.593.316 0 .632.003.908.016.292.014.682-.11 1.067.814.39.94 1.326 3.237 1.443 3.473.117.236.195.512.039.826-.156.316-.234.512-.468.788-.234.278-.494.62-.704.832-.234.234-.478.488-.206.96s1.214 2.003 2.606 3.244c1.79 1.596 3.3 2.09 3.77 2.326.468.236.74.198 1.012-.118.274-.316 1.17-1.364 1.482-1.834.312-.468.624-.39 1.054-.234.43.156 2.724 1.284 3.192 1.518.468.234.78.352.896.546.118.196.118 1.12-.272 2.218z" />
        </svg>
      </a>
    </footer>
  );
}
